export class Team {
	id?: number;
	code?: string;
	name?: string;

	constructor(init?: Partial<Team>) {
		Object.assign(this, init);
	}
}
